module.exports = __webpack_public_path__ + "img/award1.cc52d7fe.svg";